import React, { Component, PropTypes } from 'react';
import UnapprovedSessions from './unapprovedSessions';
import OnHoldSessions from "./onHoldSessions";
import Search from './search';
import './assignContracts.scss';

const styles = {
  floatLeft: {
    float: 'left'
  },
  sessionsContainer: {
    clear: 'both'
  }
};

export default class AssignContracts extends Component {

  static propTypes = {
    route: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state = {
      showOnHold: props.route.path === 'onHold'
    };
  }

  componentDidUpdate (prevProps) {
    const { path } = this.props.route;
    if (prevProps.route.path !== path && path === 'onHold') {
      this.setState({showOnHold: true});
    }
    if (prevProps.route.path !== path && !path) {
      this.setState({showOnHold: false});
    }
  }

  showOnHold() {
    this.props.history.replace('/staff/onHold')
  }

  showNotOnHold() {
    this.props.history.replace('/staff')
  }

  render () {
    const {showOnHold} = this.state;
    return (
      <div className="staff assign-contracts">
        <div>
          <h4 className="adminPageTitle">Search</h4>
          <Search history={this.props.history} route={this.props.route} routeParams={this.props.routeParams} />
        </div>
        <div>
          <a onClick={::this.showNotOnHold}><h4 className={`adminPageTitle${showOnHold ? '' : ' selected'}`} style={styles.floatLeft}>Assign Contracts</h4></a>
          <h4 className={`adminPageTitle`} style={styles.floatLeft}>&nbsp;|&nbsp;</h4>
          <a onClick={::this.showOnHold}><h4 className={`adminPageTitle${showOnHold ? ' selected' : ''}`} style={styles.floatLeft}>On Hold</h4></a>
          <div style={styles.sessionsContainer}>
          {showOnHold
            ? <OnHoldSessions />
            : <UnapprovedSessions />
          }
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/staff/assignContracts.jsx